
import { Notification } from "@/hooks/useNotificationDetail";
import { SupabaseNotification } from "@/types/notifications";
import { supabase } from "@/integrations/supabase/client";

/**
 * Helper function to log webhook operations to the database
 */
export const logWebhookResult = async (
  notification: Notification | SupabaseNotification,
  webhookType: string,
  webhookUrl: string,
  requestPayload: any,
  responseStatus: number,
  responseBody: string,
  success: boolean,
  triggeredById?: string,
  triggeredByName?: string
) => {
  try {
    await supabase.from('notification_webhook_logs').insert({
      notification_id: notification.id,
      webhook_type: webhookType,
      webhook_url: webhookUrl,
      request_payload: requestPayload,
      response_status: responseStatus,
      response_body: responseBody,
      success,
      triggered_by: triggeredById,
      triggered_by_name: triggeredByName
    });
    console.log(`Webhook log created for ${webhookType} webhook on notification ${notification.id}`);
  } catch (error) {
    console.error("Failed to log webhook result:", error);
  }
};
